/** Normalizes free-form record text into a selector-safe `data-testid` fragment. */
export function toTestIdPart(value: string | null | undefined, fallback = 'unknown'): string {
  const normalized = String(value ?? '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
  return normalized || fallback;
}
